import { PartType } from 'collections/part';

interface Lot {
  partId: number;
  partMoldParts: number[];
  partType: string;
}

export type MoldPart<T> = T & {
  parent?: T;
};

export type NestedLot<T> = T & {
  children?: MoldPart<T>[];
};

export const mapLotsToNested = <T extends Lot>(lots: T[]): NestedLot<T>[] => {
  const lotsByPartId = new Map<number, T>();
  lots.forEach((lot) => {
    if (lot.partType !== PartType.Mold) {
      lotsByPartId.set(lot.partId, lot);
    }
  });

  const nestedLots: NestedLot<T>[] = [];

  lots.forEach((lot) => {
    if (lot.partType === PartType.Mold) {
      const partMoldParts: MoldPart<T>[] = [];

      lot.partMoldParts.forEach((partId) => {
        const partMoldPart = lotsByPartId.get(partId);

        lotsByPartId.delete(partId);

        if (partMoldPart) {
          partMoldParts.push({
            ...partMoldPart,
            parent: lot,
          });
        }
      });

      nestedLots.push({
        ...lot,
        children: partMoldParts,
      });
    }
  });

  nestedLots.push(...lotsByPartId.values());

  return nestedLots;
};
